import React from "react"
import clsx from "clsx"
import AddButtonNew from "../../AddButton/AddButtonNew"
import RoomTypeBuilderErrors from "../RoomTypeBuilderErrors"
import NumberSpinner from "../../NumberSpinner/NumberSpinner"

class RoomTypeBuilderHousekeepingTypes extends React.Component {

  constructor(props) {
    super(props)

    this.onAddRoomTypeHousekeepingType = this.onAddRoomTypeHousekeepingType.bind(this);
    this.onRemoveRoomTypeHousekeepingType = this.onRemoveRoomTypeHousekeepingType.bind(this); 
    this.onChange = this.onChange.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.renderRemoveButton = this.renderRemoveButton.bind(this);
    this.getRoomTypeHousekeepingTypeIndexById = this.getRoomTypeHousekeepingTypeIndexById.bind(this)
  }

  render() {
    
    var tabClasses = clsx({
      'active': this.props.active_tab == 'housekeeping_types',
      'tab-pane': true
    })
    
    return (
      <div className={tabClasses} id="housekeeping_types">
        { this.renderErrors() }
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{ marginBottom: 0 }}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6" >
                  <h3 className="panel-title">
                    {I18n.t('housekeeping_types')}
                  </h3>
                </div>
                <div className="col-md-6 content-right flexed">
                  {
                    this.props.read_only
                      ?
                      null
                      :
                      <AddButtonNew
                        disabled={this.props.disabled}
                        new_button={false}
                        model="HousekeepingType"
                        text={I18n.t('add')}
                        ids={this.props.room_type_housekeeping_types ? this.props.room_type_housekeeping_types.map((room_type_housekeeping_type) => { return room_type_housekeeping_type.id }) : null}
                        onAdd={this.onAddRoomTypeHousekeepingType}
                        buttonClasses="btn btn-secondary"
                        generalPosition="left"
                      />
                      // <AddButton
                      //   disabled={this.props.disabled}
                      //   new_button={false}
                      //   model="HousekeepingType"
                      //   text={I18n.t('add')}
                      //   ids={this.props.room_type_housekeeping_types ? this.props.room_type_housekeeping_types.map((room_type_housekeeping_type) => { return room_type_housekeeping_type.id }) : null}
                      //   onAdd={this.onAddRoomTypeHousekeepingType}
                      //   buttonClasses="btn btn-secondary"
                      // />
                  }
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="panel-body">
                <div className="group-contract-prices"></div>
                {this.renderHousekeepingTypes() }
              </div>
            </div>
          </div>
        </div>
      </div>  
    )
  }

  renderHousekeepingTypes() {
    var self = this;
    if (this.props.room_type_housekeeping_types.length == 0) {
      return (
        <div className="no-records">
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
    var housekeeping_types = this.props.room_type_housekeeping_types.map(function (housekeeping_type, idx) {
      return (
        <div className="row ht-row" key={idx}>
          <div className="col-md-2 name-wrapper">
            <div className="form-group">
              <label>{I18n.t('housekeeping_type')}</label>
              <div>{housekeeping_type.code} ({housekeeping_type.name})</div>
            </div>
          </div>
          <div className="col-md-3" style={{ display: "flex"}}>
            <div className="form-group" style={{width: "100%"}}>
              <label>{I18n.t('frequency')}</label>
              <br />
              <select
                id="frequency"
                name={housekeeping_type.id + "|frequency"}
                value={housekeeping_type.frequency || ''}
                onChange={self.onChange}
                style={{maxWidth: "250px", margin: 0}}
                className="form-control">

                <option value="daily">{I18n.t('daily')}</option>
                <option value="every_other_day">{I18n.t('every_other_day')}</option>
                <option value="every_third_day">{I18n.t('every_third_day')}</option>
                <option value="weekly">{I18n.t('weekly')}</option>
                <option value="once_at_checkout">{I18n.t('once_at_checkout')}</option>
              </select>
            </div>
          </div>
          <div className="col-md-3" style={{ display: "flex" }}>
            <div className="form-group" style={{width: "100%"}}>
              <label>{I18n.t('estimated_minutes')}</label>
              <NumberSpinner
                name={housekeeping_type.id + "|estimated_time"}
                value={housekeeping_type.estimated_time || ''}
                onChange={self.onChange}
                max={1000000}
                className="form-control" />
            </div>
          </div>
          <div className="col-md-3">
            {/* <div className="form-group" style={{width: "100%"}}>
              <label>{I18n.t('ready_for_check_in')} <span className="ss-help help" title={I18n.t('test')}></span></label>
              <br />
              <select
                id="ready_for_check_in"
                name="room_type[ready_for_check_in]"
                value={self.props.ready_for_checkin || ''}
                onChange={self.props.onFieldChange}
                style={{maxWidth: "250px", margin: 0}}
                className="form-control">

                <option value="yes">{I18n.t('yes')}</option>
                <option value="no">{I18n.t('no')}</option>
              </select>
            </div> */}
          </div>
          {self.renderRemoveButton(housekeeping_type.id)}
        </div>
      )
    })

    return (
      <div className="housekeeping-types-form">
        {housekeeping_types}
      </div>
    )
  }

  onAddRoomTypeHousekeepingType(housekeeping_type) {
    var room_type_housekeeping_types = this.props.room_type_housekeeping_types.slice(0);
    var room_type_housekeeping_type = {
      code: housekeeping_type.code,
      name: housekeeping_type.name,
      frequency: "daily",
      id: housekeeping_type ? housekeeping_type.id : '-0',
    };

    room_type_housekeeping_types.unshift(room_type_housekeeping_type);
    this.onChangeRoomTypeHousekeepingTypes(room_type_housekeeping_types);
  } 

  onRemoveRoomTypeHousekeepingType(housekeeping_type_id) {
    var housekeeping_types = this.props.housekeeping_types.slice(0);
    var idx = this.getRoomTypeHousekeepingTypeIndexById(housekeeping_type_id);

    if (idx >= 0) {
      housekeeping_types.splice(idx, 1);
      this.onChangeRoomTypeHousekeepingTypes(housekeeping_types);
    }
  }

  onChangeRoomTypeHousekeepingTypes(room_type_housekeeping_types) {
    this.props.onChangeHousekeepingTypes({
      target: {
        value: room_type_housekeeping_types
      }
    });
  }

  renderErrors() {
    var errors = RoomTypeBuilderErrors.housekeeping_types(this.props.errors)

    if (errors && errors.length) {
      var idx = 0
      var errors = errors.map((error) => {
        idx = idx + 1
        return <li key={error + idx}>{error}</li>
      })

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  /******************
  * Change handlers *
  *******************/

  getRoomTypeHousekeepingTypeIndexById(id) {
    for (var i = 0, ilen = this.props.room_type_housekeeping_types.length; i < ilen; i++) {
      if (this.props.room_type_housekeeping_types[i].id == id) {
        return i;
      }
    }
  }

  onChange(event) {
    if (event && event.target) {

      var housekeeping_type_id = event.target.name.split('|')[0]
      var name = event.target.name.split('|')[1]

      if (this.props.room_type_housekeeping_types && this.props.room_type_housekeeping_types.length) {
        
        for (var i = 0, ilen = this.props.room_type_housekeeping_types.length; i < ilen; i++) {
          if (this.props.room_type_housekeeping_types[i].id == housekeeping_type_id) {
            this.props.room_type_housekeeping_types[i][name] = event.target.value
           
            break
          }
        }
      }

    
      this.onChangeRoomTypeHousekeepingTypes(this.props.room_type_housekeeping_types)
    }
  }

  renderRemoveButton(id) {
    if (typeof this.onRemove == 'function') {
      return (
        <div className="col-md-1 col-remove" >
          <button type="button" name={id} className="btn btn-secondary" onClick={(e) => this.onRemove(e)}>{I18n.t('remove')}</button>
        </div>
      );
    }

    return null;
  }

  onRemove(e) {
    var room_type_housekeeping_types = this.props.room_type_housekeeping_types.slice(0);
    var idx = this.getRoomTypeHousekeepingTypeIndexById(e.target.name);

    if (idx >= 0) {
      room_type_housekeeping_types.splice(idx, 1);
      this.onChangeRoomTypeHousekeepingTypes(room_type_housekeeping_types);
    }
  }

}

export default RoomTypeBuilderHousekeepingTypes